import strings from '../../Localization/Localization';

import {
  fetchProducts
} from '../../API/Products'

import {
  fetchAlphalinkMobileProductGroups
} from '../../API/AlphalinkMobileProductGroups';

import {
  getAlphalinkOfferDataOptions
} from '../../API/AlphalinkMVNO';

let product = {
  fieldKey: "product",
  label: strings.form.alphalinkDataRecharge.product.label,
  type: "dropdownEntity",

  validators: [],

  showEmpty: true,
  filterOptions: (product) => product.contract.length === 0 && (product["active_quote"] === true || product["active_order"] === true || product["active_ticket"] === true),
  loader: {
    id: "products",
    loader: fetchProducts,
    loaderRequire: () => true,
    loaderArguments: () => []
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let alphalinkMobileProductGroups = {
  fieldKey: "alphalink_mobile_product_groups",
  label: "",
  type: "array",

  submitRemoval: true,
  removalCondition: (value) => !!value,
  defaultNumberOfField: 1,
  allowMoreField: true,

  allowMoreFieldAddLabel: strings.form.alphalinkDataRecharge.alphalinkMobileProductGroup.allowMoreField.addLabel,
  allowMoreFieldRemoveLabel: strings.form.alphalinkDataRecharge.alphalinkMobileProductGroup.allowMoreField.removeLabel,
  allowMoreFieldRemovingLabel: strings.form.alphalinkDataRecharge.alphalinkMobileProductGroup.allowMoreField.removingLabel,

  validators: [],

  subField: {
    label: strings.form.alphalinkDataRecharge.alphalinkMobileProductGroup.label,
    type: "dropdownEntity",

    validators: [],

    showEmpty: true,
    filterOptions: (option, getValues) => {
      let values = getValues();
      if(values["alphalink_mobile_product_groups"] && values["alphalink_mobile_product_groups"].length > 0) {
        return option["alphalink_data_recharge_offer_parent_id"] === values["alphalink_mobile_product_groups"][0]["alphalink_data_recharge_offer_parent_id"]
      }
      return true;
    },
    loader: {
      id: "alphalinkMobileProductGroups",
      loader: fetchAlphalinkMobileProductGroups,
      loaderRequire: () => true,
      loaderArguments: () => [],
    },

    adapter: {
      requirement: (data) => data["id"] && data["name"],
      getValue: (data) => data["id"],
      getLabel: (data) => data["name"],
    },
  }
}

let quantity = {
  fieldKey: "quantity",
  label: strings.form.alphalinkDataRecharge.quantity.label,
  type: "text",

  validators: [],
}

let alphalinkOfferDataOption = {
  fieldKey: "alphalink_reference",
  type: "dropdown",
  label: strings.form.alphalinkDataRecharge.alphalinkOfferDataOption.label,
  validators: [],

  showEmpty: true,
  input: 'formValues',
  compute: (getValues, extraValues) => {
    let values = getValues();

    if(!values["alphalink_mobile_product_groups"]) {
      return [];
    }

    if(extraValues.alphalinkOfferDataOptions["request_status"] === 200) {
      return extraValues.alphalinkOfferDataOptions.result.data
        .filter((alphalinkOfferDataOption) => {
          if(alphalinkOfferDataOption["idoffer_parent"] === values["alphalink_mobile_product_groups"][0]["alphalink_data_recharge_offer_parent_id"]) {
            return true;
          }
          return false;
        })
        .map((alphalinkOfferDataOption) => {
          return {
            value: alphalinkOfferDataOption["reference"],
            label: alphalinkOfferDataOption["retailer_repackaging"]
          };
        }
      );
    }

    return []
  }
}

export const form = {
  formKey: "alphalinkDataRecharge",
  fields: [
    product,
    alphalinkMobileProductGroups,
    quantity,
    alphalinkOfferDataOption
  ],
  extraValues: {
    alphalinkOfferDataOptions: {
      type: "load",
      loader: {
        loader: getAlphalinkOfferDataOptions,
        loaderRequire: () => true,
        loaderArguments: () => [],
      }
    },
  }
}
